import { heroById, type HeroTemplate } from '@/data/heroes';
import {
  STONE_AGE_MILESTONES,
  STONE_TO_BRONZE_GATE,
  type Milestone,
} from '@/data/milestones';
import { type Party } from './party';

export const partyContributions = (party: Party): Set<string> => {
  const set = new Set<string>();
  for (const m of party.recruited) {
    const t = heroById(m.templateId);
    for (const c of t.contributions) set.add(c);
  }
  return set;
};

export interface MilestoneStatus {
  milestone: Milestone;
  covered: boolean;
  by: HeroTemplate[];
}

export const milestoneStatus = (party: Party, milestone: Milestone): MilestoneStatus => {
  const heroesInParty = party.recruited.map((m) => heroById(m.templateId));
  const by = heroesInParty.filter((h) =>
    milestone.requires.some((req) => h.contributions.includes(req)),
  );
  const covered = milestone.requires.every((req) =>
    heroesInParty.some((h) => h.contributions.includes(req)),
  );
  return { milestone, covered, by };
};

export const stoneAgeStatus = (party: Party): MilestoneStatus[] =>
  STONE_AGE_MILESTONES.map((m) => milestoneStatus(party, m));

export const canAdvanceToBronze = (party: Party): boolean => {
  const contribs = partyContributions(party);
  return STONE_TO_BRONZE_GATE.every((c) => contribs.has(c));
};
